export default __webpack_public_path__ + "static/media/studyset.4387161a.jpg";